<div class="list-wrap" cdkDrag>
    <ul class="list-wrap-list" #projectList>
        @for (item of (ggAuthService.loginStateSub.asObservable() | async).projects; track item.project.guid; let
            e = $even) {
            <li
                    [class.selected-instance]="selectedProjectGuid===item.project.guid"
                    [class.fading-instance]="selectedProjectGuid&&selectedProjectGuid!==item.project.guid"
                    class="list-wrap-list-item"
                    (click)="redirectTo(item,$event)">
                <div class="list-wrap-list-item-img">
                    <img [src]="'../../../../assets/images/logos/' + (logos[item.project.guid]?.logo||'default.png')" style="max-width: 122px;max-height: 90px;">
                </div>
                <div class="list-wrap-list-item-desc">
                    <div class="list-wrap-list-item-desc-name"> {{ item.project.name }}</div>
                    <div class="list-wrap-list-item-desc-site"> {{ item.project.domain }}</div>
                    <div class="list-wrap-list-item-desc-position">
                        <lucide-icon name="user-round" [size]="14" class="my-icon"></lucide-icon>
                        {{ item.position === 'Админ' ? 'Генеральный директор' : item.position }}
                    </div>
                    <div class="list-wrap-list-item-desc-role">
                        <lucide-icon [name]="item.is_project_admin? 'monitor-cog' : 'monitor'" [size]="14"
                                     class="my-icon"></lucide-icon>
                        {{ (item.is_project_admin ? 'LOGIN.ROLES.ADMIN' : 'LOGIN.ROLES.USER') | translate }}
                    </div>
                </div>
            </li>
        }
    </ul>
</div>
